import React from 'react';
import { wax } from '@noom/wax-component-library';
const Svg = (props) => {
    var _a;
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : 'black';
    return (React.createElement(wax.svg, Object.assign({ width: "100%", height: "100%", viewBox: "0 0 32 32", fill: "none" }, props, { xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("g", { clipPath: "url(#clip0_63_8169)" },
            React.createElement("circle", { cx: "15.75", cy: "8.75", r: "3.75", stroke: color, strokeWidth: "2" }),
            React.createElement("circle", { cx: "9.75", cy: "17.75", r: "3.75", stroke: color, strokeWidth: "2" }),
            React.createElement("circle", { cx: "22.25", cy: "17.75", r: "3.75", stroke: color, strokeWidth: "2" }),
            React.createElement("path", { d: "M9.5 22C7.01472 22 5 24.2386 5 27H14C14 24.2386 11.9853 22 9.5 22Z", stroke: color, strokeWidth: "2" }),
            React.createElement("path", { d: "M22.5 22C20.0147 22 18 24.2386 18 27H27C27 24.2386 24.9853 22 22.5 22Z", stroke: color, strokeWidth: "2" }),
            React.createElement("path", { d: "M11 15C11.9004 13.8161 13.801 13 16 13C18.199 13 20.0996 13.8161 21 15", stroke: color, strokeWidth: "2" }),
            React.createElement("path", { d: "M5 27H27", stroke: color, strokeWidth: "2" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_63_8169" },
                React.createElement("rect", { width: "24", height: "24", fill: "white", transform: "translate(4 4)" })))));
};
export default Svg;
//# sourceMappingURL=CommunityNoom.js.map